import { Button, Col, Row, Table } from 'antd';
import React, { useEffect, useState } from 'react'
import { API_ROUTE } from '../../../utils/commonConstants';
import { GET } from '../../../utils/requestActionConstants';
import { fetcher } from '../../../helpers/processRequest';
import useSWR from 'swr';
import { categoryTabConfig } from '../CategoriesTab';
import { useDispatch, useSelector } from 'react-redux';
import { setCategories, setCategory } from '../../../store/slices/categorySlice';
import SearchComponent from '../../../components/SearchComponent';


function CategoryList({onSwitchTab}) {
    const dataFetcher = useSWR({method: GET, url: API_ROUTE + '/categories'} , fetcher);
    const state = useSelector(state => state.categorySlice);
    const dispatch = useDispatch();
    const [filteredData, setFilteredData] = useState([]);

    const edit = (data) => {
        dispatch(setCategory(data))
        onSwitchTab(categoryTabConfig.ADD, data);
    }
    
    useEffect(() => {
      if (dataFetcher.data?.data) {
        dispatch(setCategories(dataFetcher.data.data));
      }
    }, [dataFetcher.data?.data])

    const columns = [
        {
          title: 'Name',
          dataIndex: 'name',
          key: 'name',
          filterSearch: true
        },
        {
          title: 'Slug',
          dataIndex: 'slug',
          key: 'slug',
          filterSearch: true
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <>
                    <div>
                        <Button onClick={() => edit(record)}>Amend</Button>
                    </div>
                </>
            )
        }
      ];

      const onFilter = (filteredData) => {
        setFilteredData(filteredData);
      }
    
      return (
        <Row gutter={[16, 16]}>
          <SearchComponent masterData={state.categoryList} onFilter={onFilter} filterByKeys={['name']} />
          <Col span={24}>
            <Table columns={columns} dataSource={filteredData} pagination={false} loading={dataFetcher.isLoading} />
          </Col>
        </Row>
      );
}

export default CategoryList